import { useSuspenseQuery } from '@tanstack/react-query';
import { fetchSimInventoryEntry } from 'src/simInventory/SimInventoryApi/simInventoryApi';
import { rsimProductDetailsQueries } from '../utils/rsimProductDetailsQueries';
import { ErrorCodes } from 'src/common/responseCodes';
import { SimData } from 'src/common/components/Sim/constants/sim';

type useRSimSimProfileProps = { euicc: string; iccid?: string };

export const useRSimSimProfile = (props: useRSimSimProfileProps, select?: any) => {
  return useSuspenseQuery<SimData | null>({
    queryKey: rsimProductDetailsQueries.profile(props),
    queryFn: () => (props.iccid ? fetchSimInventoryEntry(props.iccid, true) : null),
    refetchOnWindowFocus: true,
    retry: (failureCount, error) => {
      if (error instanceof Error && error.message === ErrorCodes.NotFound) {
        return false;
      }
      return failureCount < 3;
    },
    select,
  });
};
